import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { ICoreGrade } from '@lb/api/core/interfaces';
import { IMDDropDownOption, MDDropDownComponent, MDTagComponent } from '@melodic-ui/components';

@Component({
	selector: 'lb-step-grade-selection',
	template: `
		@if (canEdit()) {
			<md-drop-down [options]="gradeOptions()" [value]="gradeID()" [dense]="true" placeholder="Not Graded" (change)="onGradeSelected($event)">
			</md-drop-down>
		} @else {
			<md-tag [type]="currentGrade()?.color ?? 'default'">{{ currentGrade()?.gradeName ?? 'Not Graded' }}</md-tag>
		}
		<span>{{ percentage() }}%</span>
		@if (isOverride()) {
			<md-tag type="warning">Override</md-tag>
		}
	`,
	styles: `
		:host {
			display: flex;
			gap: var(--md-spacing-md);
			align-items: center;

			span {
				font-size: var(--md-typography-body1-font-size);
				color: var(--md-colors-gray-700);
			}
		}
	`,
	standalone: true,
	imports: [CommonModule, MDDropDownComponent, MDTagComponent]
})
export class StepGradeSelectionComponent {
	gradeID = input<number | null>();
	canEdit = input<boolean>(false);
	percentage = input<number>();
	grades = input.required<ICoreGrade[]>();
	isOverride = input<boolean>(false);
	onGradeChange = input<((gradeID: number | null) => void) | undefined>();

	gradeOptions = computed<IMDDropDownOption[]>(() => [
		{ value: null, label: 'Not Graded' },
		...this.grades().map((g) => ({ value: g.gradeID, label: g.gradeName }))
	]);

	currentGrade = computed(() => this.grades().find((g) => g.gradeID === this.gradeID()) ?? null);

	onGradeSelected(event: unknown): void {
		const gradeID = typeof event === 'number' ? event : null;
		this.onGradeChange()?.(gradeID);
	}
}
